import apiClient from '@/plugins/axios';

export default {
	getFlaws(params, opts = {}) {
		const langCode = localStorage.getItem('lang') || 'sv';
		params.langCode = langCode;
		params.pageNumber = params.currentPage;
		return apiClient.get('v1/Flaw', { params, ...opts });
	},

	getFlaw(flawId) {
		const langCode = localStorage.getItem('lang') || 'sv';
		return apiClient.get(`v1/Flaw/${flawId}`, { params: { langCode } });
	},

	createFlaw(flaw) {
		return apiClient.post('v1/Flaw', flaw);
	},

	updateFlaw(flaw) {
		var flawId = flaw.id;

		return apiClient.put(`v1/Flaw/${flawId}`, flaw);
	},

	deleteFlaw(flawId) {
		return apiClient.delete(`v1/Flaw/${flawId}`);
	},

	getFlawStatistic(params) {
		return apiClient.get('v1/Flaw/flawCount', { params });
	},

	getFlawAttetions(params) {
		return apiClient.get('v1/Flaw/flawsAttetions', { params });
	},

	triggerFlawMail(flawId) {
		return apiClient.get(`v1/Flaw/sendMail/${flawId}`);
	},

	GetFlawCategoriesWithFlawTypes(languageCode) {
		return apiClient.get(`v1/Flaw/GetFlawCategoriesWithFlawTypes/${languageCode}`);
	}
};
